const initialState = ''

const commentText = (state = initialState, action) => {
  switch (action.type) {
    case 'setCommentText':
      return action.payload

    default:
      return state
  }
}
export default commentText
